import { CamundaFields } from '@forvalter/utils/CamundaUtils';
import { useCurrentUser } from '@klp/auth';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useTildelKommentar } from '../../TildelKommentar/hooks/useTildelKommentar';
import type { Aktivitet } from '@klp/formgenerator/interfaces';
import type { AssignLeverandorProcessRequest } from '@klp/leverandor/services';
import { useAssignLeverandorProcessMutation } from '@klp/leverandor/services';
import type { LeverandorGodkjenningProsessResponse } from '@klp/leverandor/types';
import { showToast } from '@klpkonsern/ui';

export const useAssignResponsibleUser = (
    superOfficeContactId: LeverandorGodkjenningProsessResponse['superOfficeContactId'],
    prosessInstansId: LeverandorGodkjenningProsessResponse['prosessInstansId'],
    activity: Aktivitet,
) => {
    const history = useHistory();
    const { currentUser } = useCurrentUser();
    const [assignTask, { isLoading: assigningTask }] =
        useAssignLeverandorProcessMutation();

    const { attachComment } = useTildelKommentar(activity);
    const { t } = useTranslation();

    const handlePrepareAssignResponsibleUserRequest = (
        ansvarlig: string,
        comment: string | undefined,
    ) => {
        try {
            const request: AssignLeverandorProcessRequest = {
                superOfficeContactId,
                ansvarlig,
                formFields: comment
                    ? [
                          {
                              id: CamundaFields.TILDEL_KOMMENTARER,
                              value: attachComment(comment),
                              type: 'string',
                              validation: [],
                          },
                      ]
                    : [],
                prosessInstansId,
            };
            return request;
        } catch (error) {
            showToast({ body: error.message, type: 'error' });
        }
        return;
    };

    const handleAssignResponsibleUser = async (
        ansvarlig: string,
        comment: string | undefined,
        redirectTo?: string,
    ) => {
        if (!currentUser) return;

        const request = handlePrepareAssignResponsibleUserRequest(
            ansvarlig,
            comment,
        );
        if (!request) return;

        await assignTask(request)
            .unwrap()
            .then(() => {
                showToast({
                    body: t('prosjekt.successfulOperation'),
                    type: 'success',
                });
                redirectTo && history.push(redirectTo);
            })
            .catch(() => {
                showToast({
                    body: t('general.error.message'),
                    type: 'error',
                });
            });
    };
    return { handleAssignResponsibleUser, assigningTask };
};
